// ─────────────────────────────────────────────────────────────────────────────
// SettingsHeader — the panel's top strip: page identity on the left, the Save
// Changes button on the right. Save state is owned by the page; this component
// only renders it.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./SettingsHeader.module.css";
import { IcoGear, IcoSave } from "./icons";

export default function SettingsHeader({ onSave, saving, saved, canSave }) {
  return (
    <div className={styles.header}>
      <div className={styles.title}>
        <div className={styles.titleIcon}><IcoGear/></div>
        <div>
          <h2 className={styles.name}>Settings</h2>
          <p className={styles.sub}>Manage your platform configuration and preferences</p>
        </div>
      </div>

      {onSave && (
        <button
          className={`${styles.saveBtn} ${saved ? styles.saveBtnDone : ""}`}
          onClick={onSave}
          disabled={saving || !canSave}
        >
          <IcoSave/>
          {saving ? "Saving…" : saved ? "Saved ✓" : "Save Changes"}
        </button>
      )}
    </div>
  );
}
